// iPhone, iPad or iPod (iPadOS also reports itself as a Mac, with a touch screen)
export const isAppleMobile = (nav = typeof navigator === 'undefined' ? null : navigator) =>
  !!nav && (/iPad|iPhone|iPod/.test(nav.userAgent || '') || (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1));
